import React, { FC } from 'react';
import { Check, HorizontalRule, PanoramaFishEye } from '@mui/icons-material';
import { useTheme } from '@mui/material';

interface Props {
  rating: string | number;
}

const OpinionIndicator: FC<Props> = ({ rating }) => {
  const theme = useTheme();
  return (
    <>
      {(rating === 'POSITIVE' || rating === 'APPROVE') && (
        <Check htmlColor={theme.palette.success.main} />
      )}
      {(rating === 'NEGATIVE' || rating === 'DISAPPROVE') && (
        <HorizontalRule htmlColor={theme.palette.warning.dark} />
      )}
      {(rating === 'NO_OPINION' || rating === 'NEUTRAL') && (
        <PanoramaFishEye htmlColor={theme.palette.primary.main} />
      )}
    </>
  );
};

export default OpinionIndicator;
